import { z } from 'zod';
import { SmartBuildQuestion } from './SmartBuildQuestion';

export const SmartBuildAnswerSchema = z.object({
  id: z.nativeEnum(SmartBuildQuestion),
  value: z.string().nullish(),
});

export type SmartBuildAnswer = z.infer<typeof SmartBuildAnswerSchema>;
